function createItems(type, count, label) {
  var items = [];
  var index;
  for (index = 0; index < count; index += 1) {
    items.push({
      id: type + "-" + (index + 1),
      title: label + " " + (index + 1),
      imageUrl: "",
      orientation: type === "portrait" ? "portrait" : "landscape"
    });
  }
  return items;
}

var PORTRAIT_COUNT = 7;
var LANDSCAPE_COUNT = 5;
var VISIBLE_PORTRAIT_COUNT = 4;
var VISIBLE_LANDSCAPE_COUNT = 3;
var DEFAULT_ROTATION_SECONDS = 7;

function createDefaultHonorWall() {
  return {
    rotationSeconds: DEFAULT_ROTATION_SECONDS,
    portraits: createItems("portrait", PORTRAIT_COUNT, "竖版荣誉"),
    landscapes: createItems("landscape", LANDSCAPE_COUNT, "横版荣誉")
  };
}

function normalizeRotationSeconds(value) {
  var seconds = Number(value);
  if (!isFinite(seconds)) return DEFAULT_ROTATION_SECONDS;
  return Math.min(30, Math.max(5, Math.round(seconds)));
}

function normalizeItems(items, defaults, orientation) {
  var source = Array.isArray(items) ? items : [];
  return defaults.map(function(fallback, index) {
    var item = source[index] && typeof source[index] === "object" ? source[index] : {};
    return {
      id: item.id || fallback.id,
      title: typeof item.title === "string" ? item.title : fallback.title,
      imageUrl: typeof item.imageUrl === "string" ? item.imageUrl : "",
      orientation: orientation
    };
  });
}

function normalizeHonorWall(value) {
  var source = value && typeof value === "object" ? value : {};
  var defaults = createDefaultHonorWall();
  return {
    rotationSeconds: normalizeRotationSeconds(source.rotationSeconds),
    portraits: normalizeItems(source.portraits, defaults.portraits, "portrait"),
    landscapes: normalizeItems(source.landscapes, defaults.landscapes, "landscape")
  };
}

function takeCircular(items, offset, count) {
  var result = [];
  var start;
  var length;
  var index;
  if (!items.length) return result;
  start = ((Number(offset) || 0) % items.length + items.length) % items.length;
  length = Math.min(count, items.length);
  for (index = 0; index < length; index += 1) {
    result.push(items[(start + index) % items.length]);
  }
  return result;
}

function getVisibleHonorItems(value, offset) {
  var honorWall = normalizeHonorWall(value);
  return {
    portraits: takeCircular(honorWall.portraits, offset, VISIBLE_PORTRAIT_COUNT),
    landscapes: takeCircular(honorWall.landscapes, offset, VISIBLE_LANDSCAPE_COUNT)
  };
}

module.exports = {
  PORTRAIT_COUNT: PORTRAIT_COUNT,
  LANDSCAPE_COUNT: LANDSCAPE_COUNT,
  VISIBLE_PORTRAIT_COUNT: VISIBLE_PORTRAIT_COUNT,
  VISIBLE_LANDSCAPE_COUNT: VISIBLE_LANDSCAPE_COUNT,
  DEFAULT_ROTATION_SECONDS: DEFAULT_ROTATION_SECONDS,
  createDefaultHonorWall: createDefaultHonorWall,
  normalizeHonorWall: normalizeHonorWall,
  getVisibleHonorItems: getVisibleHonorItems
};
